import React, { Component } from "react";
// import * as firebase from 'firebase'
import firebase from "../../helper/firebase";
import _ from "lodash";

import { Link } from "react-router-dom";

import Head from '../../components/Head'
import SkeletonSectionTitle from "../../components/SkeletonSectionTitle";
import SkeletonCard from "../../components/SkeletonCard";
import LoggedOutCard from "../../components/LoggedOutCard";
// import Snack from "../../components/Snack";
import ApplicantCardHeader from "../../components/ApplicantCardHeader";
import AdminSummaryBarChart from "../../components/AdminSummaryBarChart";
import AdminJobsPieChart from "../../components/AdminJobsPieChart";
import SectionTitle from "../../components/SectionTitle";
import AdminJobSummaryCard from "../../components/AdminJobSummaryCard";
import EmptyState from "../../components/EmptyState";
import AdminTopJobsCard from "../../components/AdminTopJobsCard";
import UnauthorizedText from "../../components/UnauthorizedText";

import { AppBar, Card, CardContent, Divider } from "material-ui";
import Tabs, { Tab } from "material-ui/Tabs";
import Fade from "material-ui/transitions/Fade";

import {
  Primary,
  Title,
} from "../../helper/consts";

import "../../styles/Dashboard.css";

const style = {
  titleLink: {
    textDecoration: "underline",
    color: Primary
  },
  topJobsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between"
  }
};

export default class Admin extends Component {
  constructor() {
    super();

    this.state = {
      authLoading: true,
      jobsLoading: true,
      jobs: {},
      referred: {},
      referredLoading: true,
      selectionStages:[],
    };
  }

  componentDidMount() {
    // let references = [

    //     {uid:'',stateName:'referred',dbName:'referred',dispatchName:'JobsState/GET_REFERRED',getJobs:false},
    //   ]
    // this.props.actions.getReferences(references)
    // let references = [
    //   {uid:'',stateName:'myJobs',dbName:'myJobs',dispatchName:'JobsState/GET_MYJOBS',getJobs:true},
    // ]
    // this.props.actions.getMyListener(references)
    // this.props.actions.getSimpleInfo(`selectionStages`,'JobsState/GET_SELECTIONSTAGES')
    // this.props.actions.test(`selectionStages`,'selectionStages',dispatchName)
    // this.props.actions.setUpAdmin()

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({
          uid: user.uid,
          user: user.providerData[0],
          loggedIn: true,
          authLoading: false
        });
        this.getInfo(user.uid);
      } else {
        // ref.child(`myJobs/${uid}`).off()
        this.setState({
          uid: "",
          user: {},
          authLoading: false,
          jobsLoading: true,
          loggedIn: false,
          jobs: {},
          referred: {},
          referredLoading: true,
          selectionStages: [],
        });
      }
    });
  }

  componentWillUnmount() {
    // ref.child(`myJobs/${uid}`).off()
  }

  getInfo = async (uid) => {
    const ref = firebase.database().ref();
    let promises = [];
    let myJobs = await ref.child(`myJobs/${uid}`).orderByChild("archived").equalTo(null).once("value");
    let count = myJobs.numChildren();
    if(!myJobs.val() || count===0){
      this.props.actions.setSnack(true, "No Data");
      this.setState({
        jobsLoading: false,
        jobs: {}
      });
    }
    else{
      this.setState({tab: Object.keys(myJobs.val())[0]})
      let jobs = myJobs.val();
      myJobs.forEach(myJob => {
        const jid = myJob.val().jid;
        jobs[jid] = {}
        firebase
        .firestore()
        .collection('jobs')
        .doc(jid)
        .get()
        .then(job => {
          if(!job.data() || job.data().status!=='published'){
            Promise.reject('unpublished job')
          }
          else{
            Object.assign(jobs[jid], job.data());
            this.setState({jobs})
            return jid
          }
        })
        .then(jid => {
          const applicationsPromise = ref
            .child(`applications/${jid}`)
            .once("value")
            .then(applications => {
              jobs[jid].applications = applications.val();
              this.setState({jobs});
              return applications.val();
            })
            .then(applications => {
              if (!!applications) {
                Object.keys(applications).forEach(applicantUid => {
                  const endorsementPromise = ref
                    .child(`endorsements/${applicantUid}/${jid}`)
                    .once("value")
                    .then(endorsement => {
                      if (endorsement.val() !== null) {
                        let endorsements = jobs[jid].endorsements || {};
                        endorsements[applicantUid] = endorsement.val();
                        jobs[jid].endorsements = endorsements;
                      }
                      this.setState({jobs});
                    });
                  promises.push(endorsementPromise);
                });
              }
            });
          const myOfferPromise = ref
          .child(`myOffers/${uid}/${jid}/shareCount`)
          .once('value')
          .then(shareCount=>{
            console.log(shareCount.val());
            if (!!shareCount.val()) {
              jobs[jid].shareCount = shareCount.val();
              this.setState({jobs});
            }
          })
          const selectionStagesPromise = ref
            .child(`selectionStages`)
            .once("value")
            .then(selectionStagesSnap => {
              this.setState({selectionStages: selectionStagesSnap.val()});
            });
          const selectionPromise = ref
            .child(`selection/${jid}`)
            .once("value")
            .then(selections => {
              if (selections.val() !== null) {
                jobs[jid].selections = selections.val();
                this.setState({jobs});
              }
            });
          const invitesPromise = ref
            .child(`invites/${jid}`)
            .once("value")
            .then(invites => {
              let inviteCount = 0;
              if (invites.val() !== null) {
                let inviteCounter = invites.numChildren();
                invites.forEach(invite => {
                  inviteCounter--;
                  if (invite.val() !== null) {
                    inviteCount = inviteCount + Object.keys(invite.val()).length;
                  }
                  if (inviteCounter === 0) {
                    jobs[jid].invites = inviteCount;
                    this.setState({jobs});
                  }
                });
              }
            });
          const referredPromise = ref
            .child(`referred/${uid}`)
            .once("value")
            .then(referred => {
              if (referred.val() !== null) {
                this.setState({
                  referred: Object.keys(referred.val()),
                  referredLoading: false
                });
              } else {
                this.setState({
                  referred: [],
                  referredLoading: false
                });
              }
            });
          promises.push(applicationsPromise,selectionPromise,myOfferPromise,selectionStagesPromise,invitesPromise,referredPromise);
          count--;
          // console.log(count);
          if (count === 0) {
            Promise.all(promises)
            .then(() => {
              // console.log(this.state);
              this.setState({
                jobsLoading: false
              });
            })
            .catch(error => {
              console.log(error);
              this.props.actions.setSnack(true, `Error: ${error}`);
              this.setState({ jobsLoading: false });
            });
          }
        })
        .catch(error=>{
          console.log(error);
          this.props.actions.setSnack(true, `Error: ${error}`);
          this.setState({ jobsLoading: false });
        })
      })
    }
  };

  // getInfo = uid => {
  //   const ref = firebase.database().ref();
  //   ref
  //     .child(`myJobs/${uid}`)
  //     .orderByChild("archived")
  //     .equalTo(null)
  //     .once("value")
  //     .then(myJobsSnap => {
  //       let jobs = myJobsSnap.val();
  //       let count = myJobsSnap.numChildren();
  //       if (count === 0) {
  //         this.props.actions.setSnack(true, "No Data");
  //         this.setState({
  //           jobsLoading: false,
  //           jobs: {}
  //         });
  //         return;
  //       } else {
  //         this.setState({
  //           tab: Object.keys(myJobsSnap.val())[0]
  //         });
  //       }
  //       let promises = [];
  //       myJobsSnap.forEach(myJob => {
  //         const jid = myJob.val().jid;
  //         // let count = Object.keys(this.props.jobs.myJobs).length;
  //         // let jobs = this.props.jobs.myJobs;
  //         // Object.keys(this.props.jobs.myJobs).map(jid=>{this.props.jobs.myJobs[jid]}).forEach(myJob=>{
  //         // const jobPromise = ref.child(`jobs/${jid}`).once('value')
  //         const jobPromise = firebase
  //           .firestore()
  //           .collection("jobs")
  //           .doc(jid)
  //           // .where('jid','==',jid)
  //           // .where('status','==','published')
  //           .get()
  //           .then(job => {
  //             if (!!job.data() && job.data().status === 'published') {
  //               Object.assign(jobs[jid], job.data());
  //               this.setState({
  //                 jobs
  //               });
  //             } else {
  //               Promise.reject();
  //               this.props.actions.setSnack(
  //                 true,
  //                 "Error. Please check URL and try again."
  //               );
  //             }
  //           });
  //         const applicationsPromise = ref
  //           .child(`applications/${jid}`)
  //           .once("value")
  //           .then(applications => {
  //             jobs[jid].applications = applications.val();
  //             // jobs[jid].endorsements = {};
  //             this.setState({
  //               jobs
  //             });
  //             return applications.val();
  //           })
  //           .then(applications => {
  //             if (!!applications) {
  //               Object.keys(applications).forEach(applicantUid => {
  //                 const endorsementPromise = ref
  //                   .child(`endorsements/${applicantUid}/${jid}`)
  //                   .once("value")
  //                   .then(endorsement => {
  //                     console.log(endorsement.val());
  //                     if (endorsement.val() !== null) {
  //                       let endorsements =
  //                         jobs[jid].endorsements || {};
  //                       endorsements[applicantUid] = endorsement.val();
  //                       jobs[jid].endorsements = endorsements;
  //                     }
  //                     this.setState({
  //                       jobs
  //                     });
  //                   });
  //                 promises.push(endorsementPromise);
  //               });
  //             }
  //           });
  //         const selectionStagesPromise = ref
  //           .child(`selectionStages`)
  //           .once("value")
  //           .then(selectionStagesSnap => {
  //             this.setState({
  //               selectionStages: selectionStagesSnap.val()
  //             });
  //           });
  //         const selectionPromise = ref
  //           .child(`selection/${jid}`)
  //           .once("value")
  //           .then(selections => {
  //             if (selections.val() !== null) {
  //               jobs[jid].selections = selections.val();
  //               this.setState({
  //                 jobs
  //               });
  //             }
  //           });
  //         const invitesPromise = ref
  //           .child(`invites/${jid}`)
  //           .once("value")
  //           .then(invites => {
  //             let inviteCount = 0;
  //             if (invites.val() !== null) {
  //               let inviteCounter = invites.numChildren();
  //               invites.forEach(invite => {
  //                 inviteCounter--;
  //                 if (invite.val() !== null) {
  //                   inviteCount =
  //                     inviteCount + Object.keys(invite.val()).length;
  //                 }
  //                 if (inviteCounter === 0) {
  //                   jobs[jid].invites = inviteCount;
  //                   this.setState({
  //                     jobs
  //                   });
  //                 }
  //               });
  //             }
  //           });
  //         const referredPromise = ref
  //           .child(`referred/${uid}`)
  //           .once("value")
  //           .then(referred => {
  //             if (referred.val() !== null) {
  //               this.setState({
  //                 referred: Object.keys(referred.val()),
  //                 referredLoading: false
  //               });
  //             } else {
  //               this.setState({
  //                 referred: [],
  //                 referredLoading: false
  //               });
  //             }
  //           });
  //         promises.push(
  //           jobPromise,
  //           applicationsPromise,
  //           selectionPromise,
  //           selectionStagesPromise,
  //           invitesPromise,
  //           referredPromise
  //         );
  //         count--;
  //         if (count === 0) {
  //           Promise.all(promises)
  //             .then(() => {
  //               this.setState({
  //                 jobsLoading: false
  //               });
  //             })
  //             .catch(error => {
  //               console.log(error);
  //               this.props.actions.setSnack(true, `Error: ${error}`);
  //               this.setState({ jobsLoading: false });
  //             });
  //         }
  //       });
  //     })
  //     .catch(myJobsError => {
  //       console.log(myJobsError);
  //       this.props.actions.setSnack(true, `Error: ${myJobsError}`);
  //       this.setState({ jobsLoading: false });
  //     });
  // };

  renderJobsSummary = () => {
    let html = [];
    let title = <SectionTitle key="jobs_status" title="Jobs Status" />;
    html.push(title);
    let card = (
      <Fade key="JobsSummary" in={true}>
        <Card className="dashboardCard card">
          <ApplicantCardHeader applicant={this.state.user} />
          <Divider light />
          <CardContent className="dashboardCardContent">
            <Link style={style.titleLink} to={`/Jobs`}>
              {`Active Jobs (${Object.keys(this.state.jobs).length})`}
            </Link>
            {!this.state.jobsLoading && (
              <AdminJobsPieChart data={this.state.jobs} />
            )}
          </CardContent>
        </Card>
      </Fade>
    );
    html.push(card);
    return html;
  };
  // <p>{!this.state.referredLoading && `${this.state.referred.length} Referred People`}</p>

  renderJobsDetails = () => {
    let html = [];
    let title = <SectionTitle key="jobs_summary" title="Jobs Summary" />;
    html.push(title);
    let card = (
      <Fade key="JobsDetails" in={true}>
        <Card className="dashboardCard card">
          <ApplicantCardHeader applicant={this.state.user} />
          <Divider light />
          {!this.state.jobsLoading && (
            <CardContent className="dashboardCardContent">
              <Link style={style.titleLink} to={`/MyJobs`}>
                {`Active Jobs (${Object.keys(this.state.jobs).length})`}
              </Link>
              <AdminSummaryBarChart data={this.state.jobs} />
            </CardContent>
          )}
        </Card>
      </Fade>
    );
    html.push(card);
    return html;
  };

  handleTabChange = (event, tab) => {
    this.setState({
      tab
    });
  };

  renderJobs = () => {
    let html = [];
    let title = <SectionTitle key="job_details" title="Job Details" />;
    html.push(title);
    const { jobs, tab } = this.state;
    let activeJob = jobs[tab];
    // console.log(activeJob);
    let card = (
      <Card key="dashboard_jobs_card" className="dashboardCard card">
        <AppBar className="joinCardHeader" position="static" color="default">
          <Tabs
            centered
            fullWidth
            scrollable
            value={this.state.tab}
            onChange={this.handleTabChange}
            indicatorColor="primary"
            textColor="primary"
          >
            {Object.keys(jobs).map((jid, i) => {
              let job = jobs[jid];
              return <Tab value={job.jid} key={job.jid} label={job.title} />;
            })}
          </Tabs>
          <Divider light />
        </AppBar>
        <AdminJobSummaryCard
          selectionStages={this.state.selectionStages}
          job={activeJob}
        />
      </Card>
    );
    html.push(card);
    return html;
  };

  renderTopJobs = () => {
    const { jobs } = this.state;
    let applications = Object.keys(jobs)
      .map(jid => jobs[jid])
      .sort((a, b) => _.size(b.applications) - _.size(a.applications))
      .splice(0, 5);
    let selections = Object.keys(jobs)
      .map(jid => jobs[jid])
      .sort((a, b) => _.size(b.selections) - _.size(a.selections))
      .splice(0, 5);
    let endorsements = Object.keys(jobs)
      .map(uid => jobs[uid] || {})
      .sort((a, b) => _.size(b.endorsements) - _.size(a.endorsements))
      .splice(0, 5);
    let html = [];
    let topEndorsementsCard = (
      <AdminTopJobsCard
        key="most_endorsements"
        countName="endorsements"
        title="Most Endorsements"
        jobs={endorsements}
      />
    );
    html.push(topEndorsementsCard);
    let topAppsCard = (
      <AdminTopJobsCard
        key="most_applications"
        countName="applications"
        title="Most Applications"
        jobs={applications}
      />
    );
    html.push(topAppsCard);
    let topSelectionsCard = (
      <AdminTopJobsCard
        key="most_selections"
        countName="selections"
        title="Most Screened"
        jobs={selections}
      />
    );
    html.push(topSelectionsCard);
    return html;
  };

  // prepData=()=>{
  //   const {jobs,selectionStages,referred,myJobs,invites,selection,applications,endorsements} = this.props;
  //   // Object.keys(jobs).map(jid=>jobs[jid]).forEach()
  //   for(let jid in myJobs) {
  //     let job = myJobs[jid];
  //     job.applications = applications[jid]
  //     job.endorsements = endorsements[jid]
  //     job.invites = _.size(invites[jid])
  //     job.selections = selection[jid]
  //     job.applications = applications[jid]
  //   }
  // }

  render() {
    // console.log(this.props);
    // console.log(this.state);
    return (
      <React.Fragment>
        <Head title={`Admin | ${Title}`} />
        <div id={this.state.loggedIn ? "loggedInBody" : null} className="body">
          {this.state.loggedIn &&
            this.props.admin && (
              <div className="dashboardContainer">
                <div className="leftColumn">
                  {this.state.jobsLoading && <SkeletonSectionTitle />}
                  {this.state.jobsLoading ? (
                    <SkeletonCard header={true} content={true} />
                  ) : (
                    Object.keys(this.state.jobs).length !== 0 &&
                    this.renderJobsSummary()
                  )}
                </div>
                <div className="rightColumn">
                  {this.state.jobsLoading && <SkeletonSectionTitle />}
                  {this.state.jobsLoading ? (
                    <SkeletonCard header={true} content={true} />
                  ) : (
                    Object.keys(this.state.jobs).length !== 0 &&
                    this.renderJobsDetails()
                  )}
                </div>
                <div style={style.topJobsContainer} className="wideColumn">
                  {this.state.jobsLoading && <SkeletonSectionTitle />}
                  {this.state.jobsLoading ? (
                    <SkeletonCard header={true} content={true} />
                  ) : (
                    Object.keys(this.state.jobs).length !== 0 &&
                    this.renderTopJobs()
                  )}
                </div>
                <div className="wideColumn">
                  {this.state.jobsLoading && <SkeletonSectionTitle />}
                  {this.state.jobsLoading ? (
                    <SkeletonCard header={true} content={true} />
                  ) : (
                    Object.keys(this.state.jobs).length !== 0 &&
                    this.renderJobs()
                  )}
                </div>
              </div>
            )}
          {!this.state.jobsLoading &&
            Object.keys(this.state.jobs).length === 0 &&
            this.props.admin && (
              <EmptyState
                key="no_data"
                subject={"No Data"}
                message={
                  "Create a Job and begin sharing to start receiving data."
                }
                btnDestination={"/AddJob"}
                btnMsg={"Add a Job"}
              />
            )}

          {!this.props.authLoading &&
            this.props.loggedIn &&
            !this.props.adminLoading &&
            !this.props.admin && (
              <div className="unauthorizedTextContainer">
                <UnauthorizedText
                  text="Unauthorized"
                  subText="Access is limited"
                />
              </div>
            )}

          {!this.props.authLoading && !this.props.loggedIn && <LoggedOutCard />}
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Admin/Admin.js